// frontend/src/constants/analyticsConstants.js

// Profit Analysis
export const PROFIT_ANALYSIS_REQUEST = 'PROFIT_ANALYSIS_REQUEST';
export const PROFIT_ANALYSIS_SUCCESS = 'PROFIT_ANALYSIS_SUCCESS';
export const PROFIT_ANALYSIS_FAIL = 'PROFIT_ANALYSIS_FAIL';

// Sales Trends
export const SALES_TRENDS_REQUEST = 'SALES_TRENDS_REQUEST';
export const SALES_TRENDS_SUCCESS = 'SALES_TRENDS_SUCCESS';
export const SALES_TRENDS_FAIL = 'SALES_TRENDS_FAIL';

// Seasonal Analysis
export const SEASONAL_ANALYSIS_REQUEST = 'SEASONAL_ANALYSIS_REQUEST';
export const SEASONAL_ANALYSIS_SUCCESS = 'SEASONAL_ANALYSIS_SUCCESS';
export const SEASONAL_ANALYSIS_FAIL = 'SEASONAL_ANALYSIS_FAIL';

// Product Performance
export const PRODUCT_PERFORMANCE_REQUEST = 'PRODUCT_PERFORMANCE_REQUEST';
export const PRODUCT_PERFORMANCE_SUCCESS = 'PRODUCT_PERFORMANCE_SUCCESS';
export const PRODUCT_PERFORMANCE_FAIL = 'PRODUCT_PERFORMANCE_FAIL';

// Inventory Health
export const INVENTORY_HEALTH_REQUEST = 'INVENTORY_HEALTH_REQUEST';
export const INVENTORY_HEALTH_SUCCESS = 'INVENTORY_HEALTH_SUCCESS';
export const INVENTORY_HEALTH_FAIL = 'INVENTORY_HEALTH_FAIL';

// Dashboard Data
export const ANALYTICS_DASHBOARD_REQUEST = 'ANALYTICS_DASHBOARD_REQUEST';
export const ANALYTICS_DASHBOARD_SUCCESS = 'ANALYTICS_DASHBOARD_SUCCESS';
export const ANALYTICS_DASHBOARD_FAIL = 'ANALYTICS_DASHBOARD_FAIL';